import { AppConfig } from '../../context/AppConfig';
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface AppConfigState {
    config: AppConfig | undefined
}

const initialState: AppConfigState = {
    config: undefined
}

export const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: (create) => ({
        configLoaded: create.reducer((state, action: PayloadAction<AppConfig>) => {
            state.config = action.payload
        }),
    })
})

export const { configLoaded } = configSlice.actions
export default configSlice.reducer
